var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7226 7.02447L15.1489 2.28017C14.9071 1.5509 13.8755 1.55091 13.6336 2.28017L12.06 7.02447C11.5185 8.65713 9.99182 9.75919 8.27169 9.75919H3.28603C2.50876 9.75919 2.1899 10.7571 2.82316 11.2078L6.77112 14.0176C8.19893 15.0338 8.79682 16.8625 8.24509 18.5259L6.71715 23.1325C6.47417 23.865 7.30888 24.4817 7.93767 24.0341L12.077 21.0882C13.4623 20.1022 15.3203 20.1022 16.7056 21.0882L20.8449 24.0341C21.4737 24.4817 22.3084 23.865 22.0654 23.1325L20.5375 18.5259C19.9858 16.8625 20.5836 15.0338 22.0115 14.0176L25.9594 11.2078C26.5927 10.7571 26.2738 9.75919 25.4965 9.75919H20.5109C18.7908 9.75919 17.2641 8.65714 16.7226 7.02447ZM16.6643 1.77755C15.9386 -0.410223 12.844 -0.410228 12.1183 1.77755L10.5447 6.52185C10.2197 7.50145 9.30377 8.16268 8.27169 8.16268H3.28603C0.954228 8.16268 -0.00234187 11.1564 1.89743 12.5085L5.84538 15.3183C6.70207 15.928 7.0608 17.0253 6.72977 18.0233L5.20182 22.6299C4.47289 24.8275 6.97701 26.6774 8.86341 25.3348L13.0027 22.3889C13.8339 21.7973 14.9487 21.7973 15.7799 22.3889L19.9192 25.3348C21.8056 26.6774 24.3097 24.8275 23.5807 22.6299L22.0528 18.0233C21.7218 17.0253 22.0805 15.928 22.9372 15.3183L26.8851 12.5085C28.7849 11.1564 27.8283 8.16268 25.4965 8.16268H20.5109C19.4788 8.16268 18.5628 7.50145 18.2379 6.52185L16.6643 1.77755Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.b4f2de967c269d9809f71004dfbf095d.svg";
export { ForwardRef as ReactComponent };